// extracted by mini-css-extract-plugin
export var actionButton = "_9o-0";
export var attachmentLine = "_9o-1";
export var fileInput = "_9o-2";
export var fileUploadWrapper = "_9o-4";
export var footer = "_9o-3";
export var modalContent = "_9o-5";
export var paperclip = "_9o-6";
export var quillEditor = "_9o-7";